import type { OpenShiftRequestsFields } from '@/data/openshiftRequests/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

export type FetchOpenShiftRequestResponse = {
  openshiftapprovalrequest: OpenShiftRequestsFields;
};

export type FetchOpenShiftRequestParams = {
  id: number;
  include_trimmed_data?: boolean;
};

export const fetchOpenShiftRequest = createWiwAsyncThunk<FetchOpenShiftRequestResponse, FetchOpenShiftRequestParams>(
  'openshiftRequests/fetchById',
  async ({ id, ...params }, { rejectWithValue }) => {
    try {
      return (await Monolith.url(`/openshiftapprovalrequests/${id}`)
        .query(params)
        .get()) as FetchOpenShiftRequestResponse;
    } catch (error) {
      return rejectWithValue(parseAPIError(error));
    }
  },
);
